@if (formField(); as field) {
  <app-input-password
    [color]="hasError() ? 'red' : 'primary'"
    [label]="field.label"
    [(value)]="value"
    [disabled]="field.disabled!"
    [required]="field.required!"
    [labelPosition]="field.labelPosition!"
    [placeholder]="_placeholder()"
    [regExp]="field.regExp ? 'true' : 'false'"
  />
}
